import { render, staticRenderFns } from "./formato-form.vue?vue&type=template&id=cfe5f6d0&scoped=true"
import script from "./formato-form.vue?vue&type=script&lang=js"
export * from "./formato-form.vue?vue&type=script&lang=js"
import style0 from "./formato-form.vue?vue&type=style&index=0&id=cfe5f6d0&prod&scoped=true&lang=css"
import style1 from "./formato-form.vue?vue&type=style&index=1&id=cfe5f6d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe5f6d0",
  null
  
)

export default component.exports